// Aviso que bloquea el cobro mientras una promo o código siga sin revalidar.
import { useNavigate } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/kit';
import { PROMOTION_REVALIDATION_MESSAGE } from '../promotionRevalidation';
import { WizardWarningNotice } from './WizardWarningNotice';

export function PromotionRevalidationNotice({ sessionId }: { sessionId: string }) {
    const navigate = useNavigate();
    return (
        <WizardWarningNotice
            action={
                <Button
                    size="sm"
                    variant="secondary"
                    leftIcon={<ArrowLeft className="size-3.5" aria-hidden />}
                    onClick={() =>
                        void navigate({
                            to: '/wizard/s/$sessionId/$step',
                            params: { sessionId, step: 'build-sale' },
                        })
                    }
                >
                    Volver a Arma la venta
                </Button>
            }
        >
            {PROMOTION_REVALIDATION_MESSAGE}. En Arma la venta se vuelve a aplicar antes de cobrar.
        </WizardWarningNotice>
    );
}
